import { Injectable } from '@angular/core';
import { CityService } from '@city/feature';
import { createEffect } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { distinct, map, pairwise } from 'rxjs/operators';
import { CityAnalyticsService } from '../services';

@Injectable()
export class CityAnalyticsEffects {
  setActiveBaseSite$: Observable<void> = createEffect(
    () =>
      this.cityService.currentCity$.pipe(
        distinct(),
        pairwise(), // это специальная имплементация
        map(([oldCity, newCity]) => {
          if (oldCity && newCity && oldCity.baseStoreId !== newCity.baseStoreId) {
            this.cityAnalyticsService.onChangeCity(oldCity, newCity);
          }

          return;
        }),
      ),
    { dispatch: false },
  );

  constructor(
    private cityService: CityService,
    private cityAnalyticsService: CityAnalyticsService,
  ) {}
}
